<template>
    <div>
      <CustomTable
          title="Настройка параметров типа конструкции"
          :rowsData="this.rowsData"
          :columns="this.frameTypesColumns"
          :loading="isFetching"
          :small="true"
          :show-search="true"
          :custom-body="true"
          :sticky-header="true"
          :update-data="this.getData">
          <!-- :add-btn="true"
          :on-add-click="this.handleAddClick" -->
        <template #customBody="props">
          <q-tr>
            <custom-table-cell align="center">
              <Clickable @click="() => this.handleUpdateClick(props.row.frame_type_id)">
                {{ props.row.frame_type_id }}
              </Clickable>
            </custom-table-cell>
            <custom-table-cell align="left">
              {{ props.row.frame_type_name }}
            </custom-table-cell>
          </q-tr>
        </template>
      </CustomTable>
    </div>
  </template>
  
  <script>
  import CustomTable from "@/components/common/CustomTable";
  import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
  import {useCustomSnackbar} from "@/_helpers/hooks/useCustomSnackbar";
  import {appActions} from "@/services/store/modules/app_module/app_actions";
  import CustomIcon from "@/components/common/CustomIcon";
  import {MODAL_NAMES} from "@/constants";
  import Clickable from "@/components/common/Clickable";
  import CheckOrClose from "@/components/common/CheckOrClose";
  import {
    frameTypesColumns,
    getAllFrameTypes,
    // updateBalance,
    // deleteBalance,
  } from "@/views/Frames/Types/services";
  
  export default {
    name: "FrameTypes",
    components: {CheckOrClose, Clickable, CustomIcon, CustomTableCell, CustomTable},
    data() {
      return {
        frameTypesColumns,
        rowsData: [],
        isFetching: false,
        deleteLoading: {},
        loading: false,
      }
    },
    methods: {
      async getData() {
        this.isFetching = true
        const res = await getAllFrameTypes()
        this.isFetching = false
        if (!res) return
        this.rowsData = res
      },
      // async handleAddClick() {
      //   this.$store.commit(appActions.showModal(MODAL_NAMES.FRAME_TYPE_PARAMS, {
      //     onSubmit: this.onAddSubmit,
      //     title: 'Добавить баланс',
      //   }));
      // },
      async handleUpdateClick(frame_type_id) {
        this.$store.commit(appActions.showModal(MODAL_NAMES.FRAME_TYPE_PARAMS, {
          // onSubmit: (body) => this.onUpdateSubmit(body),
          title: 'Параметры',
          frame_type_id: frame_type_id
        }));
      },
      // async onAddSubmit(body) {
      //   const res = await updateBalance(body)
      //   if (!res) return
      //   this.rowsData = res
      //   this.showSucceedSnackbar()
      //   this.$store.commit(appActions.closeModal());
      // },
      // async onUpdateSubmit(body) {
      //   const res = await updateBalance(body)
      //   if (!res) return
      //   this.rowsData = res
      //   this.showSucceedSnackbar()
      //   this.$store.commit(appActions.closeModal());
      // },
      // async onDeleteSubmit(frame_type_id) {
      //   this.deleteLoading[frame_type_id] = true
      //   const res = await deleteBalance(frame_type_id)
      //   this.deleteLoading[frame_type_id] = false
      //   if (!res) return
      //   this.rowsData = res
      //   this.showSucceedSnackbar()
      // },
    },
    mounted() {
      this.getData()
    },
    setup() {
      const {showSucceedSnackbar} = useCustomSnackbar();
      return {showSucceedSnackbar};
    },
  }
  </script>